import type { Space } from '@mail/cross-sizes-utils';
import { autoUploadPromo } from 'reactApp/appHelpers/featuresHelpers/features/autoUploadPromo';
import {
    isShowEditingDocumentFeatureEnabled,
    SHOW_EDITING_DOCUMENT_SHORT_FEATURE_TEXT,
} from 'reactApp/appHelpers/featuresHelpers/features/showEditingDocumentFeature';
import { SPACE_LIST } from 'reactApp/constants/spaceList';

const FEATURES_MODAL_DATA = [
    'Больше места для файлов',
    'Никакой рекламы в Почте и Облаке',
    'Загрузка файлов до 100 ГБ',
    'Добавление в подписку до 3 близких',
    'Автоудаление отправленных файлов',
    'Автосохранение файлов с телефона',
    'Онлайн-доступ с любого устройства',
    'Отмена письма в течение 30 секунд',
    'Виджеты Календаря и Задач на виду',
    'Проверка вложений антивирусом',
    'Отдельные папки для рассылок и\u00A0чеков',
    'Приоритетная поддержка',
];

export const getFeaturesModalList = (space?: Space, isFamily?: boolean) => {
    const features = [...FEATURES_MODAL_DATA];

    if (autoUploadPromo && space && space?.original >= SPACE_LIST.gb_256) {
        features.splice(2, 0, 'Безлимитная автозагрузка фото и видео с\u00A0телефона');

        if (isFamily) {
            features.splice(5, 0, 'Семейные папки и альбомы');
        }
    }

    if (space && space?.original >= SPACE_LIST.gb_256) {
        features.splice(1, 0, 'Удаление дубликатов');
    }

    if (isShowEditingDocumentFeatureEnabled && space && space?.original >= SPACE_LIST.gb_512) {
        return [...features, SHOW_EDITING_DOCUMENT_SHORT_FEATURE_TEXT];
    }

    return features;
};
